// extracted by mini-css-extract-plugin
export default {"root":"userview_root__T6hiA"};